const messages = {
    buttons: {
        productBrochures: "Avasta",
    },
    index: {
        title: "TOOTEINFO",
        description: "Laadige siit alla meie Bridgestone ja Firestone rehvide uusimad brošüürid ja lendlehed.",
        categories: {
            productBrochures: {
                title: "Tootebrošüürid",
                description: "Bridgestone ja Firestone rehvisarjade brošüürid",
            },
            bDrive: {
              title: "Toodete pildid",
              description: "Värsked pildid on allalaaditavad meie B-DRIVE portaalist.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

